
import { BlogPost } from '../types';
import { beginnerIntroPost } from './beginner-intro';
import { beginnerMistakesPost } from './beginner-mistakes';
import { teachingChildrenPost } from './teaching-children';

// Combine all beginner posts
export const beginnerPosts: BlogPost[] = [
  beginnerIntroPost,
  beginnerMistakesPost,
  teachingChildrenPost
];
